import { useEffect, useState } from "react";
import { getLinks } from "../utils/GraphqlUtils";
import { Link } from './Link';

const LinkTable = () => {
  const [links, setLinks] = useState<Link[]>([]);
  const [loading, setLoading] = useState(true);
  console.log("Fetching LinkTable");

  useEffect(() => {
    getLinks()
      .then(setLinks)
      .catch((err) => console.error("Failed to fetch links:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <table border={1} cellPadding={8}>
      <thead>
        <tr>
          <th>URL</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        {links.map((link, index) => (
          <tr key={index}>
            <td>{link.url}</td>
            <td>{link.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default LinkTable;
